export const physicsData = {
  departmentName: "Department of Physics",
  bannerImage: "/physics/PhysicsBanner.JPG",
  
  about: {
    title: "About the Department",
    content: `The Department of Physics at Rayalaseema University offers comprehensive education in both theoretical 
    and experimental physics. Our programs cover classical mechanics, quantum mechanics, electromagnetism, thermodynamics, 
    and modern physics. We focus on developing strong foundation in physics principles with emphasis on research, 
    innovation, and practical applications. The department is equipped with state-of-the-art laboratories and 
    research facilities to nurture future physicists and researchers.`,
    highlights: [
      "Advanced physics laboratories with modern equipment",
      "Research in condensed matter physics and material science",
      "Spectroscopy and characterization facilities",
      "Active participation in national and international conferences",
      "Strong emphasis on computational physics"
    ]
  },

  brochure: {
    title: "Department Brochure",
    pdfLink: "/physics/department-brochure.pdf",
    description: "Download our department brochure."
  },

  hod: {
    id:'phy001',
    name: "Dr. C. V. Krishna Reddy",
    designation: "Professor and Head",
    photo: "/physics/cvkredd.JPG",
    email: "reddycvk02@yahoo.co.in",
    mobile: "9989642920",
    qualification: "M.Sc., M.Phil., Ph.D., UGC-NET",
    specialization: "Solid State Spectroscopy",
    message: `Welcome to the Department of Physics at Rayalaseema University. We are committed to excellence in 
    physics education and research. Our department provides a stimulating environment for students to explore the 
    fundamental laws of nature and their applications. We encourage innovation, critical thinking, and scientific 
    inquiry to prepare students for successful careers in research, academia, and industry.`,
    profileLink: "/physics/CV-KRISHNA-REDDY.pdf"
  },

  bos: {
  title: "Physics",
  members: [
    {
      name: "Prof. C.V. Krishna Reddy",
      designation: "Chairperson",
      affiliation: "Dept. of Physics, Rayalaseema University, Kurnool"
    },
    {
      name: "Prof. K. Krishna Reddy",
      designation: "Member",
      affiliation: "Dept. of Physics, Yogi Vemana University, Kadapa"
    },
    {
      name: "Prof. M. V. Lakshmaiah",
      designation: "Member",
      affiliation: "Dept. of Physics, S.K. University, Anantapur"
    },
    {
      name: "Prof. S. Vijaya Bhaskar Rao",
      designation: "Member",
      affiliation: "Dept. of Physics, S.V. University, Tirupati"
    },
    {
      name: "Prof. K.T. Ramakrishna Reddy",
      designation: "Member",
      affiliation: "Dept. of Physics, S.V. University, Tirupati"
    },
    {
      name: "Sri K. Dhanujaya",
      designation: "Member",
      affiliation: "Vice President, Aditi Solar Pvt. Ltd., Hyderabad"
    }
  ]
}
,

  faculty: [
    {
      id:'phy001',
      name: "Dr. C. V. Krishna Reddy",
      designation: "Professor and Head",
      email: "reddycvk02@yahoo.co.in",
      mobile: "9989642920",
      photo: "/physics/cvkredd.JPG",
      qualification: "M.Sc., M.Phil., Ph.D.,UGC-NET",
      specialization: "Solid State Spectroscopy ",
      profileLink: "/physics/CV-KRISHNA-REDDY.pdf"
    },
    {
      id:'phy002',
      name: "Dr. G. K. Siva Sankara Yadav",
      designation: "Assistant Professor (C)",
      email: "gkssyadav@gmail.com",
      mobile: "9441510086",
      photo: "/physics/yadav.JPG",
      qualification: "M.Sc., M.Phil., Ph.D.",
      specialization: "Materials Science ",
      profileLink: "/physics/GK-SIVA-SANKARA-YADAV.pdf"
    },
    {
      id:'phy003',
      name: "Dr. E. Rajasekhar",
      designation: "Assistant Professor (C)",
      email: "physics.rajasekhar@gmail.com",
      mobile: "9985075726",
      photo: "/physics/rajasekhar.JPG",
      qualification: "M.Sc., Ph.D.,CSIR-NET,TSSET",
      specialization: "APPLIED PHYSICS /  ELECTRONICS  ",
      profileLink: "/physics/RAJASEKHAR.pdf"
    }
  ],

  courses: {
    // undergraduate: [
    //   {
    //     name: "B.Sc. Physics",
    //     duration: "3 Years",
    //     eligibility: "10+2 with Physics and Mathematics",
    //     intake: "60 seats"
    //   }
    // ],
    postgraduate: [
      {
        name: "M.Sc. Physics",
        duration: "2 Years",
        eligibility: "B.Sc. with Physics",
        intake: "30 seats"
      }
    ],
    research: [
      {
        name: "Ph.D. in Physics",
        duration: "Minimum 3 Years",
        eligibility: "M.Sc. Physics",
        areas: "Solid State Spectroscopy, Material Science, Applied Physics"
      }
    ]
  },

  Infrastructure: [
"/infrastructure/physics/lab-4.JPG",
"/infrastructure/physics/lab-5.JPG",
"/infrastructure/physics/lab-6.JPG",
"/infrastructure/physics/lab-7.JPG",
  "/infrastructure/physics/lab-5.JPG",
  "/infrastructure/physics/lab-6.JPG",
  "/infrastructure/physics/lab-7.JPG",
  "/infrastructure/physics/lab-8.JPG",
  "/infrastructure/physics/lab-9.JPG",
  "/infrastructure/physics/lab-10.JPG",
]
};
